module.exports = __webpack_public_path__ + "img/Turks and Caicos Islands.5b5badd4.svg";